export const privacyPolicyObj = {
  topSubHeading: "Scale Smarter with Expert Talent",
  heading: "Transform Your Requirements into a Clear SRS Roadmap",
  subHeading:
    "Upload your project requirements & our experts will prepare a structured Software Requirement Specification (SRS) or Strategic Plan. Ensure clarity, scalability, & a roadmap that drives business growth.",
  emailLabel: "Your Work Email",
  requiredDcoument: "Upload Requirement Document",
  submitBtn: "Submit & Receive SRS Plan",
  loading: "Loading...",
};

export const cookiesObj = {
  heading: "Your Privacy",
  description:
    "Bitsclan uses essential cookies & similar technologies to ensure the optional operation of our website & to offer you a tailored user experience. For more information, please review our",
  policyLink: "Policy",
  acceptBtn: "Accept",
  rejectBtn: "Reject",
};
